import { render, staticRenderFns } from "./Component.vue?vue&type=template&id=54abf90e&scoped=true"
import script from "./Component.vue?vue&type=script&lang=ts"
export * from "./Component.vue?vue&type=script&lang=ts"
import style0 from "./Component.vue?vue&type=style&index=0&id=54abf90e&prod&lang=scss&scoped=true"
import style1 from "./Component.vue?vue&type=style&index=1&id=54abf90e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54abf90e",
  null
  
)

export default component.exports